import { createAsyncThunk } from "@reduxjs/toolkit";
import couponsService from "../../../api/services/coupons";

export const createCoupon = createAsyncThunk(
  "coupons/create-coupon",
  async (requestData) => {
    return await couponsService.createCoupon(requestData);
  }
);

export const getCoupons = createAsyncThunk("coupons/get-coupons", async () => {
  return await couponsService.getCoupons();
});

export const checkCoupon = createAsyncThunk(
  "coupons/check-coupon",
  async (code) => {
    return await couponsService.checkCoupon(code);
  }
);

export const deleteCoupon = createAsyncThunk(
  "coupons/delete-coupon",
  async (id) => {
    return await couponsService.deleteCoupon(id);
  }
);
